import React from 'react'
import i18n from 'atpjs/helpers/i18n'
const t = i18n.prefix(['components', 'appointmentGrid', 'requestError'])

const RequestError = ({ phone, reloadCurrentDate }) => {
  const [phoneNumber, tel] = phone

  return (
    <div className="atp-notification">
      <p>
        {t(['title'])}
        <br />
        <button className="atp-link" onClick={reloadCurrentDate}>
          {t(['retry'])}
        </button>
      </p>
      <p className="atp-margin-bottom-no">
        {t(['phone'])}
        <br />
        <a href={`tel:${tel}`} className="atp-notification__bold-text">
          {phoneNumber}
        </a>
      </p>
    </div>
  )
}

export default RequestError
